var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoundownShape = function SvgCoundownShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 561,
    height: 128,
    fill: "none",
    viewBox: "0 0 561 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#313851",
    fillOpacity: 0.15,
    d: "M524.208 1.5H36.792a17 17 0 0 0-15.745 10.592l-18.518 45.5a17 17 0 0 0 0 12.816l18.518 45.5A17 17 0 0 0 36.792 126.5h487.416a17 17 0 0 0 15.745-10.592l18.518-45.5a17 17 0 0 0 0-12.816l-18.518-45.5A17 17 0 0 0 524.208 1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_7555_7387)",
    fillOpacity: 0.35,
    d: "M524.208 1.5H36.792a17 17 0 0 0-15.745 10.592l-18.518 45.5a17 17 0 0 0 0 12.816l18.518 45.5A17 17 0 0 0 36.792 126.5h487.416a17 17 0 0 0 15.745-10.592l18.518-45.5a17 17 0 0 0 0-12.816l-18.518-45.5A17 17 0 0 0 524.208 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#paint1_linear_7555_7387)",
    strokeWidth: 2,
    d: "M524.208 1.5H36.792a17 17 0 0 0-15.745 10.592l-18.518 45.5a17 17 0 0 0 0 12.816l18.518 45.5A17 17 0 0 0 36.792 126.5h487.416a17 17 0 0 0 15.745-10.592l18.518-45.5a17 17 0 0 0 0-12.816l-18.518-45.5A17 17 0 0 0 524.208 1.5Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7555_7387",
    x1: -26.556,
    x2: 662.823,
    y1: -208.021,
    y2: 291.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D1DBFF",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D1DBFF",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D7E0FF",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE7FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7555_7387",
    x1: 1,
    x2: 560,
    y1: -29.5,
    y2: -29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A3046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1F253D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#4D536A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#1F2539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A3046"
  })))));
};
export default SvgCoundownShape;